

























































































































































































































































































import debounce from "lodash/debounce";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  minLength,
  sameAs
} from "vuelidate/lib/validators";

import { getFieldError } from "@/core/tools/forms/get_field_error";

import { STORE_KEY, store } from "./_store";
import Attachments from "@/components/Controls/Attachments.vue";
import ParentProductCombobox from "@/components/Controls/ParentProductCombobox.vue";
import SemifinishedProductCombobox from "@/components/Controls/SemifinishedProductCombobox.vue";

@Component({
  mixins: [validationMixin],
  computed: {
    ...mapState(STORE_KEY, [
      "loaded",
      "loading",
      "fatalError",
      "document",
      "form",
      "meta",
      "semifinishedRows"
    ]),
    ...mapGetters(STORE_KEY, ["fields"]),
    ...mapState("ubic", ["token"])
  },
  methods: {
    getFieldError
  },
  components: {
    Attachments,
    ParentProductCombobox,
    SemifinishedProductCombobox
  },
  validations() {
    const rules: any = {
      name: { required, minLength: minLength(3) },
      code: {},
      vat_id: {},
      position: {},
      promo_name: {},
      teaser: {},
      promo_image_url: {},
      pick_up_product: {},
      show_in_catalog: {},
      is_semifinished: {},
      archived_at: {},
      type_id: { required }
    };

    return {
      form: rules
    };
  }
})
export default class ProductForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  document!: any;
  form!: any;
  semifinishedRows!: any[];
  public dropFiles = [];

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  // id сохранённого документа: после создания продукта окно остаётся
  // открытым, и повторное сохранение должно идти через update
  public savedDocumentId: any = null;

  get currentProductId() {
    return this.documentPreview ? this.documentPreview.id : null;
  }

  get hasInvalidSemifinishedRows(): boolean {
    if (this.form && this.form.is_semifinished) {
      return false;
    }
    return this.semifinishedRows.some(
      (_row: any, index: number) => this.rowPercentError(index) !== null
    );
  }

  @Watch("form.is_semifinished")
  onIsSemifinishedChange(newVal: any, oldVal: any) {
    console.debug("[ProductForm.isSemifinished]", { newVal, oldVal });
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }
  FILES_HOST = process.env.VUE_APP_UBIC_SERVER_ADDRESS;

  public mounted() {
    console.log("this.isNew)", this.isNew);
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field,
      newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  saveFormData() {
    this.$v.form.$touch();

    if (this.hasInvalidSemifinishedRows) {
      console.debug("[ProductForm.saveFormData] blocked by semifinished rows");
      this.$buefy.snackbar.open({
        type: "is-warning",
        message:
          "Проверьте расход полуфабрикатов: значение должно быть числом от 0 до 100"
      });
      return;
    }

    if (!this.$v.form.$error) {
      const documentId =
        this.savedDocumentId ||
        (this.documentPreview ? this.documentPreview.id : null);

      this.$store
        .dispatch(`${STORE_KEY}/saveForm`, documentId)
        .then(result => {
          this.$buefy.snackbar.open(`Данные успешно сохранены`);
          this.$v.form.$reset();

          if (result && result.document && result.document.id) {
            this.savedDocumentId = result.document.id;
          }

          // окно остаётся открытым: перезагружаем документ и состав,
          // чтобы повторное сохранение не дублировало строки состава
          if (this.savedDocumentId) {
            this.$store.dispatch(`${STORE_KEY}/init`, {
              id: this.savedDocumentId
            });
          }

          console.debug("[ProductForm.saveFormData] saved", {
            documentId: this.savedDocumentId
          });
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: "is-warning",
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          });
        });
    }
  }

  addAttachments(file: any) {
    this.$store.dispatch(`${STORE_KEY}/addAttachments`, { newValue: file });
  }

  async addSemifinishedProduct(product: any) {
    if (!product) {
      return;
    }

    const added: any = await this.$store.dispatch(
      `${STORE_KEY}/addSemifinishedRow`,
      { product }
    );

    if (!added) {
      this.$buefy.snackbar.open({
        type: "is-warning",
        message: "Этот полуфабрикат уже добавлен"
      });
    }
  }

  removeSemifinished(index: number) {
    this.$store.dispatch(`${STORE_KEY}/removeSemifinishedRow`, { index });
  }

  changeSemifinishedPercent(index: number, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeSemifinishedRowValue`, {
      index,
      newValue: value
    });
  }

  rowPercentError(index: number): string | null {
    const row = this.semifinishedRows[index];
    if (!row) {
      return null;
    }

    const raw = row.consumption_percent;
    if (raw === null || raw === undefined || String(raw).trim() === "") {
      return "Укажите расход";
    }

    const num = Number(raw);
    if (Number.isNaN(num)) {
      return "Должно быть числом";
    }
    if (num < 0 || num > 100) {
      return "От 0 до 100";
    }

    return null;
  }

  removeFile(row: any, idx: number) {
    row.attachments.splice(idx, 1);
    this.saveFormData();
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}
